import {get, post, postDownload} from './fetch.js'

export const shopCR = pageInfo?.cr || 'US';

/*-- 老带新 --*/
export const referNew = (params) => post("/v1/invite-new/old", { shopify_shop_id: shopId, ...params })
export const referOld = (params) => post("/v1/invite-new/new", { shopify_shop_id: shopId, ...params })
/*-- 老带新 --*/


/*-- jackery life --*/
// 获取活动时间节点信息
export const getLifeActivityNodeTime = params => get("/life-api/api/consumer/getActivityDetail", { shopifyShopId: shopId, ...params })

// 获取活动排行榜信息
export const getLifeActivityRank = (params, settings) =>
    get("/life-api/api/consumer/getActivityCharts", { shopifyShopId: shopId, ...params, }, settings)

// 获取explore所有活动排行榜
export const getLifeExploreRank = params => get("/life-api/api/consumer/getAllCharts", { shopifyShopId: shopId, ...params })
/*-- jackery life --*/

/*-- stories 招募页 --*/
export const addStoriesRecruit = (params) => post("/osconsumerapi/cusumer/stories/join", { shopifyShopId: shopId, ...params })
export const newAddStoriesRecruit = (params) => post("/osconsumerapi/cusumer/stories/newjoin", { shopifyShopId: shopId, ...params })
/*-- stories 招募页 --*/


/*-- 报价单 --*/
export const quotation = (params) => post("/osconsumerapi/v1/order-quotation/subscribe", { shopify_shop_id: shopId, ...params })
/*-- 报价单 --*/

/*-- 报价单 view --*/
export const quotationPreview = (params) => post("/v1/order-quotation/preview", { ...params })
/*-- 报价单 view --*/


/*-- 报价单 download --*/
export const quotationExport = (token) => get(`/v1/export/file?token=${token}`)
/*-- 报价单 download --*/

/*-- 报价单 add --*/
export const quotationAdd = (params) => post("/v1/order-quotation/add", { ...params })
/*-- 报价单 add --*/


// 创建会员价优惠券
export const createMembershipPriceCoupon = params => post("/osconsumerapi/v1/active/create-coupon", params)
// 查询会员价活动产品
export const getMembershipPriceActiveProducts = params => post("/osconsumerapi/v1/active/index", params)
// 查询商详页会员价
export const getMembershipPriceProductInfo = params => post("/osconsumerapi/v1/active/product-member-benefit", params)
// 获取积分余额
export const getPointAccount = () => get('/userapi/v1/point/pointAccount')

// 老带新
// 老带新配置
export const getOldInviteNewConfig = () => get("/osconsumerapi/v1/old-invite-new/config", { shopifyShopId: shopId, })

// 获取老客推荐信息
export const getOldReferInfo = params => post("/osconsumerapi/v1/old-invite-new/older-info", { shopifyShopId: shopId, ...params })

// 生成推荐链接
export const createReferLink = params => post("/osconsumerapi/v1/old-invite-new/refer", { shopifyShopId: shopId, ...params })

// 发送老带新邮件
export const sendInviteEmail = params => post("/osconsumerapi/v1/old-invite-new/send-invite-email", { shopifyShopId: shopId, ...params })

// 获取新客订阅title
export const getOldInviteNewTitle = () => get("/osconsumerapi/v1/old-invite-new/title", { shopifyShopId: shopId, })

// 新客订阅接口
export const oldInviteNewSubscribe = (params) => post("/osconsumerapi/v1/old-invite-new/subscribe", { shopifyShopId: shopId, ...params })

// 老带新排行榜
export const getOldInviteNewRank = (params) => get("/osconsumerapi/v1/old-invite-new/get-rank-list", { shopifyShopId: shopId, ...params })
// 老带新，获取邮箱排名
export const getOldInviteNewEmailRank = (params) => get("/osconsumerapi/v1/old-invite-new/get-email-rank", { shopifyShopId: shopId, ...params })

// 捆绑销售
export const getProductBundledInfo = (params) => post("/osconsumerapi/v1/app-bundled-sale/info", { shopifyShopId: shopId, ...params })

// 产品优惠券
export const getProductCouponInfo = (params) => get("/osconsumerapi/v1/app-coupon/info", { shopifyShopId: shopId, ...params })


// 新人教育对比
export const getNewcomerProductCompare = () => get("/osconsumerapi/cus/four/smartshop/charging-times", { shopifyShopId: shopId})

// 故事新增评论
export const storiesComment = (params) => post("/osconsumerapi/v1/comment/stories/add", { shopShopifyId: shopId, ...params })

// 故事评论列表
export const getStoriesCommentList = (params) => get("/osconsumerapi/v1/comment/stories/list", { shopShopifyId: shopId, ...params })

// 故事招募页国家下拉
export const getCountryList = () => get("/osconsumerapi/v1/service/country-info", { shopifyShopId: shopId })


export const getCountryApi_test = () => get("/osconsumerapi/shopify/shop-lists", { shopify_shop_id: shopId });

// get product all info
// { shopify_shop_id, sku }
export const getGoodsInfo = (param) => get("/osconsumerapi/v1/goods/info", param);



// 获取套装商品详情
export const getPackagedInfo = (param) => get("/osconsumerapi/v1/goods/packaged-info", param);

// shopify host logout
export const shopifyLogout = () => get(`${location.origin}/account/logout`);

// shopify get sections
export const shopifySection = (section) => get(`${location.origin}/?sections=${section}`);

// shopify add to cart
export const shopifyCartAdd = (param) => post(`${location.origin}/cart/add.js`, param);

// account system check user availability
export const shopifyUserCheck = (checkJackeryToken = "") => get("/userapi/v1/user/check", {check_jackery_token: checkJackeryToken});

// get a coupon for a single product
export const getCouponInfo = (variantId, price) => {
  price && (price = parseFloat(price / 100).toFixed(2));
  return get("/v1/app-coupon/info", { sku_id: variantId, price })
};

// get coupons for multiple products
// [{ sku_id: variantId, price }]
export const batchCouponInfo = (param) => get("/v1/app-coupon/batch-info", param);

// product shortage tips
export const shortage = (param) => post("/v1/notice/add", param);

// jackery day collection for answer active email
// param: {shopify_shop_id: '{{ shop.id }}'}
export const getServerTime = () => get("/v1/com/get-server-time", { shopify_shop_id: shopId });

// get notify current info
export const notifyInfo = () => get("/v1/app-message/info", { union_id: cookie.get("_shopify_y"), shopify_shop_id: shopId });

// notify popup
export const notifyPopup = (param) => post("/v1/app-message/popup", param);

// footer电话订阅
export const footerPhoneSubs = (params) => post("/osconsumerapi/v1/notice/subscribe", { shopify_shop_id: shopId, ...params });


// 智能选购相关接口
// 功能是否开启
export const isHelpChooseOpen = () => get('/osconsumerapi/cusumer/smartshop/openstutas', {shopifyShopId: shopId})

// 获取 主场景列表
export const getMainScene = () => get('/osconsumerapi/cusumer/smartshop/mianscene', {shopifyShopId: shopId})

// 添加 其他主场景
export const addOtherMainScene = (params) => post('/osconsumerapi/cusumer/smartshop/other-main-scene', {shopifyShopId: shopId, ...params})

// 获取 子场景列表
export const getSubScene = (params) => get('/osconsumerapi/cusumer/smartshop/subscene', {shopifyShopId: shopId, ...params})

// 获取 电器列表
export const getElectrical = (params) => post('/osconsumerapi/cusumer/smartshop/electrical', {shopifyShopId: shopId, ...params})

// 获取 储能和太阳能板子推荐
export const getBothGoods = (params) => post('/osconsumerapi/cusumer/smartshop/bothgoods', {shopifyShopId: shopId, ...params})

// 获取 储能和太阳能板子价格和参数
export const getBothGoodsPrice = (params) => post('/osconsumerapi/cusumer/smartshop/price', {shopifyShopId: shopId, ...params})

// 获取 储能单品推荐
export const getResultSingleGoods = (params) => post('/osconsumerapi/cusumer/smartshop/singlegoods', {shopifyShopId: shopId, ...params})

// 获取 储能 + 太阳能板 推荐
export const getResultGoodsList = (params) => post('/osconsumerapi/cusumer/smartshop/goodslist', {shopifyShopId: shopId, ...params})

// 获取 储能下拉列表
export const getEnergyList = (params) => get('/osconsumerapi/cusumer/smartshop/energylist', {shopifyShopId: shopId, ...params})

// 获取 太阳能列表
export const getSolarList = (params) => get('/osconsumerapi/cusumer/smartshop/solarlist', {shopifyShopId: shopId, ...params})

// 获取 太阳能列表
export const getRecommendProducts = (params) => post('/osconsumerapi/cusumer/smartshop/page/recommend', {shopifyShopId: shopId, ...params})

// 获取 产品延保信息
export const getProductWarrantyInfo = (params) => get('/osconsumerapi/cusumer/smartshop/warranty', {shopifyShopId: shopId, ...params})


// 通过产品ID获取捆绑销售详情
export const bundleSale = (params) => get('/osconsumerapi/app-bundle-sale/consumer/info', {shopifyShopId: shopId, ...params})

// 通过产品ID获取产品对比信息
export const productContrast = (params) => get('/osconsumerapi/app-product-comparison/consumer/compareInfo', {shopifyShopId: shopId, ...params})

// 通过产品ID获取产品基础属性信息
export const productBaseInfo = (params) => get('/osconsumerapi/app-product-comparison/consumer/detail', {shopifyShopId: shopId, ...params})
// 获取选定产品的对比信息
export const productSelectCompareInfo = (params) => get('/osconsumerapi/app-product-comparison/consumer/selectCompareInfo', {shopifyShopId: shopId, ...params})

// 获取系列所有产品
export const productAllCompareInfo = (params) => get('/osconsumerapi/app-product-comparison/consumer/allCompareInfo', {shopifyShopId: shopId, ...params})

/*-- 新客任务 --*/
// C端：获取活动详情接口
export const customerInfo = (params) => get('/osconsumerapi/v1/newcomer-subscribe/info', {shopify_shop_id: shopId, ...params});

// C端：参与活动接口
// export const customerJoin = (params) => get('/osconsumerapi/v1/newcomer-subscribe/join', {shopify_shop_id: shopId, ...params});
export const customerJoin = (params) => post('/osconsumerapi/v1/newcomer-subscribe/new-join', {shopify_shop_id: shopId, ...params});

// C端：获取奖品结果接口
export const customerResult = (params) => get('/osconsumerapi/v1/newcomer-subscribe/result', {shopify_shop_id: shopId, ...params});

// C端：电话订阅接口
export const customerPhone = (params) => get('/osconsumerapi/v1/newcomer-subscribe/accepts-sms', {shopify_shop_id: shopId, ...params});

// C端：数据上报接口
export const customerPopData = (params) => get("/v1/newcomer-subscribe/popup", {shopify_shop_id: shopId, ...params});

// C端：人机校验接口
export const checkRobot = (params) => post("/osconsumerapi/v1/newcomer-subscribe/robot-check", {shopify_shop_id: shopId, ...params});
/*-- 新客任务 --*/

// become-reseller页面submit
export const resellerSubmit = (params) => post("/osconsumerapi/v1/service/dealer-application", {...params});

/*-- contact us页面 --*/
// C端：contact us页面-前端表单转发到对应收集邮件邮件
export const contactMediaSubmit = (params) => post("/osconsumerapi/v1/service/media-cooperation", {...params});

// C端：contact us页面-上传文件
export const contactMediaUpload = (params) => post("/osconsumerapi/v1/aws/upload?type=2", params, {feature: 'upload'});

// C端：contact us页面-获取分类数据   osconsumerapi/contact/us/consult/field/detail
export const getCategory = (params) => get("/osconsumerapi/contact/us/consult/field/detail", {...params});
// export const getCategory = (params) => get("/shopconsult/open/consult/field/17948055445787/detail", {...params}, {type:'it-java'});

// C端：contact us页面-获取商品数据
// export const getProductName = (params) => get("/open/consult/field/5845813794575/detail", {...params}, {type:'it-java'});
// export const getProductName = (params) => get("/shopconsult/open/consult/field/7492361159707/detail", {...params}, {type:'it-java'});
export const getProductName = (params) => get("/osconsumerapi/contact/us/consult/field/group", {...params});

// C端：contact us页面-zendesk上传附件
export const zendeskUpload = (params) => post("/osconsumerapi/contact/us/consult/upload", params, {feature: 'upload'});

// C端：contact us页面-zendesk提交表单
// export const zendeskSubmit = (params) => post("/shopconsult/open/consult/create", {...params}, {type:'it-java'});

export const zendeskSubmit = (params) => post("/osconsumerapi/contact/us/consult/create", {...params});

// industry列表
export const getIndustryList = (params) => get("/osconsumerapi/contact/us/consult/field/industry", {...params});

// 提交 - 批量购买再用
export const zendeskContactSubmit = (params) => post("/osconsumerapi/contact/us/retailPage/create", {...params});

/*-- contact us页面 --*/
// 获取ip列表
export const regoinlist = (params) => get("/osconsumerapi/cusumer/ip/regoinlist", { shopifyShopId: shopId, ...params });

// 获取会员最大权益-未登录
export const getMembershipBenefits = params => get("/osconsumerapi/v1/point/benefits/public", { shopifyShopId: shopId, ...params })

// 获取会员最大权益-已登录
export const getLoginMembershipBenefits = params => get("/userapi/v1/point/benefits/login", { shopifyShopId: shopId, ...params })


// 获取心愿单配置-心愿单
export const getGoodsWishList = params => get("/osconsumerapi/v1/goods/get-goods-wish-list", { shopifyShopId: shopId, ...params })

// 更新心愿单-心愿单
export const updateGoodsWishList = params => post("/osconsumerapi/v1/cust-wish-list/update-wish-list", { shopifyShopId: shopId, ...params })

// 登出接口
export const accountLogout = () => get("/userapi/v1/user/logout", {shopifyShopId: shopId})

// 地图接口 - 地图列表
export const getStoreList = params => post("/osconsumerapi/v1/map/list", { shopifyShopId: shopId, ...params })

// 获取地图国家
export const getCountryOrRegionList = params => get("/osconsumerapi/v1/map/country", { shopifyShopId: shopId, ...params })

// 获取地图省份
export const getProvinceList = params => get("/osconsumerapi/v1/map/province", { shopifyShopId: shopId, ...params })

// 获取地图城市
export const getCityList = params => get("/osconsumerapi/v1/map/city", { shopifyShopId: shopId, ...params })
// 批量购买--列表
export const getBatchPurchaseList = () => get("/osconsumerapi/v1/app-batch-discount/bulkInfo", {shopifyShopId: shopId})

// 上传免税证明
export const uploadBatchPurchaseInfo = (params) => post("/osconsumerapi/v1/tax/upload", {shopShopifyId: shopId, ...params})

// 下载报价单
export const downloadBatchPurchaseExcal = (params) => postDownload('/osconsumerapi/v1/app-batch-discount/download', {shopShopifyId: shopId, ...params})

// 日站下载报价单
export const downloadJpBatchPurchaseExcal = (params) => postDownload('/osconsumerapi/v1/app-batch-discount/download-jp', {shopShopifyId: shopId, ...params})

// C端 批量上传：-上传文件  下次要改下
export const batchPurchaseUpload = (type, params) => post(`/osconsumerapi/v1/aws/upload?type=${type}`, params, {feature: 'upload'});

// 根据产品spuid来获取产品详细信息
export const getProductInfo = params => get("/osconsumerapi/v1/goods/productInfo", { shopifyShopId: shopId, ...params })

// 根据cr获取城市
export const countryStreetInfo = (params) =>  get('/osconsumerapi/v1/service/country-info', { shopifyShopId: shopId, ...params });

// 发送邮件
export const sendEmailAPI = (params) => post("/osconsumerapi/v1/com/email", { ...params });

// 12周年--获取商品列表sku
export const getGoodsList = () => get("/osconsumerapi/api/jackerylife/goods", { shopifyShopId: shopId });

// 12周年 -- 新增评论表单
export const addComment = (params) => post("/osconsumerapi/v1/comment/twelve/add", {shopShopifyId: shopId, ...params})

// 12周年--评论列表
export const getCommentList = (params) => get("/osconsumerapi/v1/comment/twelve/list", { shopShopifyId: shopId, ...params });

// 说明书
export const getManualList = (params) => get("/osconsumerapi/v1/goods/user-guides", { shopifyShopId: shopId, ...params });

// 获取AWS S3桶鉴权信息
export const getAwsS3Data = () => get("/osconsumerapi/v1/aws/get-sts", { auth: false });

// 获取付费延保服务信息
export const getPEWServiceInfo = (params) => get("/osconsumerapi/v1/paid-extended-warranty/get-service-info", {...params });

// 校验付费延保项目是否已激活或待审核（不包含取消）
export const checkPEWProject = (params) => get("/osconsumerapi/v1/paid-extended-warranty/check-warranty-project", {...params });

// 提交付费延保绑定申请
export const applyPEW = (params) => post("/osconsumerapi/v1/paid-extended-warranty/apply", {...params})


// 产品对比 - 获取产品列表
export const getCompareGoodsList = (params) => get("/osconsumerapi/v1/app-four-comparison/consumer/collection-goods", { shopifyShopId: shopId, ...params });

// 产品对比 - 获取详情
export const getCompareDetail = (params) => post("/osconsumerapi/v1/app-four-comparison/consumer/collection-detail", { shopifyShopId: shopId, ...params });

// 产品对比5.0 - 获取对比详情
export const getCompareDetailV5 = (params) => post("/osconsumerapi/v1/app-four-comparison/consumer/collection-detail-five", { shopifyShopId: shopId, ...params });

/** 智能选购 4.0 */
// 获取主场景列表
export const getSceneList = (params) => get('/osconsumerapi/cus/four/smartshop/scene', { shopifyShopId: shopId, ...params })
// 获取电器列表
export const getElectricalList = (params) => get('/osconsumerapi/cus/four/smartshop/electrical', { shopifyShopId: shopId, ...params })
// 查询最大功率
export const queryMaxPower = (params) => get('/osconsumerapi/cus/four/smartshop/maxpower', { shopifyShopId: shopId, ...params })
// 储能单品推荐
export const getRecommendEnergy = (params) => get('/osconsumerapi/cus/four/smartshop/energy', { shopifyShopId: shopId, ...params })
// 储能和太阳能板子推荐
export const getRecommendEnergySolar = (params) => get('/osconsumerapi/cus/four/smartshop/energysolar', { shopifyShopId: shopId, ...params })
// 储能太阳能板配件最后推荐
export const getRecommendSolution = (params) => get('/osconsumerapi/cus/four/smartshop/solution', { shopifyShopId: shopId, ...params })
// Get My Offer
export const getMyOffer = (params) => post('/osconsumerapi/cus/four/smartshop/myoffer', { shopifyShopId: shopId, ...params })
/** 智能选购 4.0 */

/** 智能选购 5.0 */ 
// 获取问题列表
export const getQuestionList = (params) => get('/osconsumerapi/cus/five/smartshop/ques', { shopifyShopId: shopId, ...params })
// 获取推荐产品
export const getV5RecommendProduct = (params) => get('/osconsumerapi/cus/five/smartshop/ques/product', { shopifyShopId: shopId, ...params })
/** 智能选购 5.0 */

/** 用户反馈 */
export const saveUserFeedback = (params) => post('/osconsumerapi/four/smart/shop/user/feedback', { shopifyShopId: shopId, ...params })
/** 用户反馈 */

// Google 人机校验
export const googleRobotCheck = (params) => post("/osconsumerapi/consumer/act/robot-check", {...params });

// 产品推荐
export const getGoodsRecommend = (params) => get("/osconsumerapi/v1/goods/get-recommends", { shopifyShopId: shopId, ...params });
// 获取站点下单积分规则
export const getPointsRatio = (params) => get('/osconsumerapi/v1/point/getRatio', params)


export const getCountry = (params) => get('/osconsumerapi/consumer/act/get-country', params)
// 验证当前账户是否已存在
export const getUserExistStatus = (params) => get("/userapi/v1/user/exist", params)

// 获取注册优惠券
export const getRegisterCoupon = () => get("/userapi/v1/user/get-register-coupon", {shopifyShopId: shopId})

// 获取智能选购产品
export const getEnergy = (params) => get("/osconsumerapi/cus/four/smartshop/pageenergy", {shopifyShopId: shopId, ...params})

// 获取太阳能板
export const getSolar = (params) => get("/osconsumerapi/cus/four/smartshop/pagesolar", {shopifyShopId: shopId, ...params})

//获取配件
export const getSolution = (params) => get("/osconsumerapi/cus/four/smartshop/solution", {shopifyShopId: shopId, ...params})


// 会员首页 -> 我的积分余额、我的奖励、我的活动积分明细
// 【已登录】获取用户账户的积分余额
export const pullBalanceAmount =() => get("/userapi/v1/point/pointAccount")
// 【已登录】获取账户积分明细
export const getAccountPointsDetail = params => get("/userapi/v1/point/pointLog", {shopifyShopId: shopId, ...params})

// 【已登录】获取用户可以兑换的权益，从小到大，优惠券
export const getCustomerCouponsList = (params) => get('/userapi/v1/point/rights/customer/coupons', {shopifyShopId: shopId, ...params});
// 【已登录】获取用户可以兑换的权益，从小到大，实物优惠券
export const getCustomerCouponsThingList = (params) => get('/userapi/v1/point/rights/customer/coupons/things', {shopifyShopId: shopId, ...params});
// 【已登录】获取用户可以兑换的权益，从小到大，礼品卡
export const getCustomerGiftcardList = (params) => get('/userapi/v1/point/rights/customer/giftcards', {shopifyShopId: shopId, ...params});
// 【已登录】获取用户可以兑换的权益，从小到大，虚拟卡
export const getCustomerVirtualCardsList = (params) => get("/userapi/v1/point/rights/customer/virtualcards", {shopifyShopId: shopId, ...params})

// 【已登录】已兑换 还未使用， 优惠券列表
export const getMyRewardsCoupons = (params) => post("/userapi/v1/point/myrewards/coupons/list", {shopifyShopId: shopId, ...params})
// 【已登录】已兑换 还未使用， 礼品卡列表
export const getMyRewardsGiftCard = (params) => post("/userapi/v1/point/myrewards/giftcards/list", {shopifyShopId: shopId, ...params})
// 【已登录】已兑换 还未使用， jackery 实物列表
export const getMyRewardsThings = (params) => post("/userapi/v1/point/myrewards/things/list", {shopifyShopId: shopId, ...params})
// 【已登录】已兑换 还未使用， 虚拟卡列表
export const getMyRewardsVirtualCard = (params) => post("/userapi/v1/point/myrewards/virtualcards/list", {shopifyShopId: shopId, ...params})

// 会员首页 -> 会员权益 -> 兑换途径
// 【未登录】获取站点账户权益积分（未登录）
export const getRulePointAndIssueStatus = params => get("/osconsumerapi/v1/point/rights/public/getRulePointAndIssueStatus", {shopifyShopId: shopId, ...params})
// 【已登录】获取个人当前站点账户积分，以及 是否发放过 邮件和短信订阅 的积分
export const getCustomerRulePointAndIssueStatus = params => get("/userapi/v1/point/rights/customer/getRulePointAndIssueStatus", {shopifyShopId: shopId, ...params})

// 会员首页 -> 会员权益 -> 权益兑换
// 【未登录】获取优惠券权益列表
export const getCouponsList = (params) => get('/osconsumerapi/v1/point/rights/public/coupons', {shopifyShopId: shopId, ...params});
// 【未登录】获取礼品卡权益列表
export const getGiftCardsList = (params) => get('/osconsumerapi/v1/point/rights/public/giftcards', {shopifyShopId: shopId, ...params});
// 【未登录】获取 jackery 实物权益列表
export const getJackeryThingsList = (params) => get('/osconsumerapi/v1/point/rights/public/coupons/things', {shopifyShopId: shopId, ...params});
// 【未登录】获取 虚拟卡权益列表（其他部分）
export const getVirtualCardsList = (params) => get("/osconsumerapi/v1/point/rights/public/virtualcards", {shopifyShopId: shopId, ...params})

// 【已登录】兑换权益
export const exchangeRight = (params) => post(`/userapi/v1/point/rights/customer/exchange?ruleId=${params.ruleId}&version=${params.version}` )
